var accessToken = typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem('graphql_access_token');
export default accessToken;